import { createContext, useContext } from 'react';
import { jsx } from 'react/jsx-runtime';

const DataContext = /*#__PURE__*/createContext(new Proxy({}, {
  get: () => {
    throw new Error("DataContext.get(): OpgaveKomplekset data context hasn't been initialized.");
  },
  set: () => {
    throw new Error("DataContext.set(): OpgaveKomplekset data context hasn't been initialized.");
  },
  apply: () => {
    throw new Error("DataContext.apply(): OpgaveKomplekset data context hasn't been initialized.");
  }
}));
function ComponentDataProvider(props) {
  return /*#__PURE__*/jsx(DataContext.Provider, {
    value: props.component,
    children: props.children
  });
}
function useOpgavekompleksetComponent() {
  return useContext(DataContext);
}

export { ComponentDataProvider, useOpgavekompleksetComponent };
//# sourceMappingURL=context.data.js.map
